import 'custom-event-polyfill';
// import external dependencies
import 'jquery';
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import postTypeArchiveAteliers from './routes/archive-ateliers'
import lePoleDetail from './routes/le-pole-detail'
import espaceAdherent from './routes/espace-adherent'
import espaceAdherentPasswordReset from './routes/espace-adherent-password-reset'
import espaceAdherentMesCoordonnees from './routes/espace-adherent-mes-coordonnees'
import espaceAdherentConnexion from './routes/espace-adherent-connexion'
import espaceAdherentAgenda from './routes/espace-adherent-agenda'
import espaceAdherentDocuments from './routes/espace-adherent-documents'
import espaceAdherentForgotPassword from './routes/espace-adherent-forgot-password'
import espaceAdherentAnnuaire from './routes/espace-adherent-annuaire'


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  postTypeArchiveAteliers,
  lePoleDetail,
  espaceAdherent,
  espaceAdherentPasswordReset,
  espaceAdherentMesCoordonnees,
  espaceAdherentConnexion,
  espaceAdherentAgenda,
  espaceAdherentDocuments,
  espaceAdherentForgotPassword,
  espaceAdherentAnnuaire,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents()
});



// WEBPACK FOOTER //
// ./scripts/main.js